const Row = ({ children, className = '' }: any) => {
    return (
        <div className={'flex flex-row ' + className}>
            {children}
        </div>
    )
}

export default Row;